import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//? English Version
import retractLockInstruction1 from "../../../assets/img/tutorialimages/retractLockGuide1.png";
//? Japanese Version
import retractLockInstruction1Jap from "../../../assets/img/tutorialimages/retractLockGuide1_Jap.png";

class RetractLockGuidebot extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { language } = this.state;
    return (
      <div
        style={{
          width: "80%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
          className="imgStyle"
          src={
            language === "en"
              ? retractLockInstruction1
              : language === "ja"
              ? retractLockInstruction1Jap
              : language === "es"
              ? retractLockInstruction1
              : retractLockInstruction1
          }
          alt="retractLockInstruction1"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
      </div>
    );
  }
}

export default RetractLockGuidebot;
